/* eslint-disable jsx-a11y/anchor-is-valid */
import { Flex } from 'antd';
import Tag from 'Components/Tag/Tag';
import useCalcualatorAIScore from 'Containers/Teleconsult/Main/FinishConsult/hooks/useCalcualatorAIScore';
import { getLabelConsult } from 'Helpers/consult-utils';
import { formatDateTimeLocal } from 'Helpers/date-utils';
import { upperFirst } from 'lodash';
import Space from 'Modules/Space';
import User from 'Modules/User/User';
import moment from 'moment';
import { func, shape } from 'prop-types';
import { Label } from 'semantic-ui-react';
import { useSelector } from 'react-redux';

import styles from '../MessageBot.less';

const ContentConsult = ({ consult, openHS, healthSummary }) => {
  const { createdAt, forPatient, consultFee, status, patient, doctor } = consult;

  const {
    data: { enableAiChecker },
  } = useSelector(state => state.webChat.doctor);

  const doctors = consult?.doctors || [];
  const otherDoctors = doctors.filter(_doctor => _doctor.id !== doctor?.id);

  let textConsultFee = 'Free';
  if (consultFee) {
    const fee = consultFee.totalPrice;
    textConsultFee = `${fee} ${consultFee.currency}`;
  }

  let description = `${
    forPatient?.genderAtBirth ? `${upperFirst(forPatient?.genderAtBirth)},` : ''
  } ${forPatient?.nric}`;

  description += forPatient?.dateOfBirth
    ? `, ${moment(forPatient?.dateOfBirth).format('DD MMM YYYY')}`
    : '';

  const requestedBy = `${patient?.fullName} (${
    patient?.genderAtBirth ? `${upperFirst(patient?.genderAtBirth)},` : ''
  } ${patient?.nric}, ${
    patient?.dateOfBirth ? moment(patient?.dateOfBirth).format('DD MMM YYYY') : ''
  })`;

  const bookedForName =
    forPatient?.fullName || `${forPatient?.firstName || ''} ${forPatient?.lastName || ''}`;

  const score = healthSummary?.evaluation?.score ?? null;
  const { scoreLabel, color } = useCalcualatorAIScore(score);

  return (
    <div>
      <div className={styles.item}>
        <Space direction="horizontal" alignItems="start" size={8} className={styles.bookedFor}>
          <img
            className={styles.avatar}
            src={forPatient.avatarUrl ?? require('Assets/images/pages/web-chat/avatar-default.png')}
            alt=""
          />
          <Space direction="vertical" alignItems="start" size={0}>
            <div>Booked for</div>
            <h3>{bookedForName}</h3>
            <p>{description}</p>
          </Space>
        </Space>
      </div>
      {otherDoctors?.length > 0 && (
        <div className={styles.item}>
          <div className={styles.title}>Invited Doctor(s)</div>
          <div className={styles.description}>
            {otherDoctors.map(({ id, fullName, title, avatarUrl }) => (
              <User key={id} image={avatarUrl} title={fullName} description={title} />
            ))}
          </div>
        </div>
      )}
      {forPatient.id !== patient.id && (
        <div className={styles.item}>
          <div className={styles.title}>Requested by</div>
          <div className={styles.description}>{requestedBy}</div>
        </div>
      )}
      <div className={styles.item}>
        <div className={styles.title}>Consult time</div>
        <div className={styles.description}>
          <span>{formatDateTimeLocal(createdAt)}</span>
          <Label content={getLabelConsult(status)} />
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.title}>Total consult fee</div>
        <div className={styles.description}>{textConsultFee}</div>
      </div>
      {healthSummary && (
        <div className={styles.item}>
          <div className={styles.content}>
            <Flex gap={8} alignItems="center">
              <strong>Consult summary</strong>
              {scoreLabel && enableAiChecker && (
                <Tag style={{ borderRadius: 100 }} color={color}>
                  {scoreLabel}
                </Tag>
              )}
            </Flex>
            <a onClick={openHS}>Details</a>
          </div>
        </div>
      )}
    </div>
  );
};

ContentConsult.propTypes = {
  consult: shape({}).isRequired,
  healthSummary: shape({}).isRequired,
  openHS: func.isRequired,
};

ContentConsult.defaultProps = {};

export default ContentConsult;
